import React from 'react'
import { withStyles, createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import { Paper, Typography, TextField, Icon, IconButton, LinearProgress, CircularProgress, Switch, FormControlLabel, AppBar, Toolbar, Tabs, Tab } from '@material-ui/core'
import Header from '../../components/Header'
import BgImage from '../../resources/images/dragon-bg.jpg'

const styles = theme => ({
  root: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'stretch'
  },
  content: {
    padding: 20,
    backgroundImage: `url(${BgImage})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    flexGrow: 1,
    backgroundAttachment: 'fixed'
  }
})

class Home extends React.Component {
  constructor () {
    super()
  }

  render() {
    const { classes } = this.props
    return (
      <Paper className={classes.root} elevation={1}>
        <Header/>
        <div className={classes.content}>
          <h1>English-Chinese Parallel Concordancer</h1>
          <p style={{fontSize: 'large'}}>The English-Chinese Parallel Concordancer is a corpus project led by Dr Wang Lixun (lixun@eduhk.hk) at the Department of Linguistics and Modern Language Studies, the Education University of Hong Kong. Users can search the English-Chinese parallel corpus online (size: 4.5 million Chinese characters, 2.9 million English words). Users can choose to do parallel concordancing or monolingual concordancing, and can choose different corpus files according to their needs. The search results will be generated automatically and can be downloaded as a Excel file.</p>
          <div style={{position: 'fixed', bottom: 10, fontSize: 'small'}}>
            <p>&copy; All Rights Reserved. The Education University of Hong Kong. With additional technical support by the Education University of Hong Kong Library.</p>
            <p>Project leader: Dr. Wang Lixun. Program designers: Chow Ka Po, Wang Lixun</p>
          </div>
        </div>
      </Paper>
    )
  }
}

export default withStyles(styles)(Home)
